import { Button } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const ActionButton = styled(Button)`
  width: 40px;
  margin-top: auto;
`
